import React, { useState } from "react"
import PropTypes from "prop-types"
import { Card, Row, Button, ModalBody, ModalFooter, Form, Col, Input, Label, FormFeedback, Alert } from "reactstrap"
import i18n from "../../../i18n"
import { useDispatch } from "react-redux";
import * as Yup from 'yup';
import { useFormik } from "formik";
import Select from "react-select";
import { map } from "lodash"
import { Link } from "react-router-dom";

const Step3 = (props) => {

  const { setShowModalModify, setStep, setModifyRoutingModal, selectRouting, newAddress, newDestination, setSelectRouting } = props;

  const dispatch = useDispatch();
  const [arrScales, setArrScales] = useState([]);

  const [rowsScale, setRowsScale] = useState(selectRouting.scales);
  const autoformik = useFormik({
    initialValues: {
      name: ""
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Required")
    })
  });

  const back = () => {
    setStep(2);
  }
  
  const sendRequest = () => {
    setStep(1)
    setShowModalModify(true)
    setModifyRoutingModal(false)
    setSelectRouting(null)
  }

  const handleAddRowScale = () => {
    if(rowsScale.length == 0){
      setRowsScale([{id: 1}])
    }else{
      const newRowScale = { id: rowsScale[rowsScale.length-1].id+1 };
      setRowsScale([...rowsScale, newRowScale]);
    }
  }

  const handleRemoveRowScale = (id) => {
    if(rowsScale.length == 1)
      return;

    const updatedRows = rowsScale.filter((row) => row.id !== id);
    setRowsScale(updatedRows);
  }

  const onChangeAddScalesRow = (formRow, val, type) => {
    let rowScale = null
    let address = type == "address" ? val.target.value : ""
    let passenger = type == "passenger" ? val.value : ""
    if(arrScales.length == 0){
      arrScales.push({ id: formRow.id, address: address, passenger: passenger })
    }else{
      rowScale = arrScales.filter(function(opt) {
        return opt.id === formRow.id
      }).shift();
      if(rowScale){
        rowScale.address = type == "address" ? val.target.value : rowScale.address
        rowScale.passenger = type == "passenger" ? val.value : rowScale.passenger
        arrScales.splice(arrScales.indexOf(rowScale), 1)
        arrScales.push(rowScale)
      }else{
        arrScales.push({ id: formRow.id, address: address, passenger: passenger })
      }
    }
    setArrScales(arrScales)
  }

  return (
    <Card>
      <ModalBody>
        <h5 className="">{i18n.t("ModifyAddresses")}</h5>
        <Row>
          <div className="col-1 text-center">
            <a className="btn btn-danger btn-small btn-rounded fs-8">1</a>
          </div>
          <div className="align-self-center col-10 line-danger"></div>
          <div className="col-1">
            <a className="btn btn-danger btn-small btn-rounded fs-8">2</a>
          </div>
        </Row>
        <Row className="pb-2 pt-4">
          <p>{i18n.t("CurrentScales")}</p>
          <Col>
            {map(selectRouting.scales, (routing, key) => (
              <p key={key}>{`${i18n.t("Scale")} ${key+=1}: ${routing.address}`}</p>
            ))}
          </Col>
          <p>{i18n.t("Scales")}</p>
          <Form className="row gy-2 gx-3 align-items-center" onSubmit={autoformik.handleSubmit}>
            <div className="inner-repeater mb-4">
              <table style={{ width: "100%" }}>
                <tbody>
                  {(rowsScale || []).map((formRow, key) => (
                    <tr key={key}>
                      <td>
                        <Row>
                          <Col xxl={6} md={6} xs={6}>
                            <div className="col-sm-auto mb-2">
                              <Label className="visually" htmlFor="scaleAddressInput">{i18n.t("Scale") + " " + (key+1)}</Label>
                              <Input 
                                type="text"
                                name="scales[][address]"
                                className="form-control"
                                id="passengerInput"
                                placeholder={i18n.t("Address")}
                                onBlur={(val) => onChangeAddScalesRow(formRow, val, "address")}
                                 />
                            </div>
                          </Col>
                          <Col md="5" xs="5">
                            <div className="mb-3">
                              <Label>{i18n.t("Passenger")}</Label>
                              <Select
                                name="scales[][passenger]"
                                placeholder={i18n.t("NotAssigned")}
                                options={[]}
                                className="select2-selection"
                                onChange={(val) => onChangeAddScalesRow(formRow, val, "passenger")}
                              />
                            </div>
                          </Col>
                          <Col md="1" xs="1">
                            <div className="d-grid mt-4">
                              <Link
                                className="text-center"
                                onClick={() => handleRemoveRowScale(formRow.id)}>
                                <i className="fa fa-trash text-danger"></i>
                              </Link>
                            </div>
                          </Col>
                        </Row>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              { parseInt(selectRouting.numberScales) >= rowsScale.length+1 ?
                <Link
                  className="text-dark"
                  onClick={() => {
                    handleAddRowScale();
                  }}
                >
                  <i className="bx bx-plus" />
                  {i18n.t("AddScale")}
                </Link> : null
              }
            </div>
          </Form>
        </Row>
      </ModalBody> 
      <ModalFooter>
        <Button type="button" className="btn-danger" color="secondary" onClick={sendRequest}>
          {i18n.t("Request")}
        </Button>
        <Button type="button" className="btn-light" color="secondary" onClick={back}>
          {i18n.t("Back")}
        </Button>
      </ModalFooter>
    </Card>
  )
}

Step3.propTypes = {
  setShowModalModify: PropTypes.func,
  setStep: PropTypes.func,
  setModifyRoutingModal: PropTypes.func,
  newAddress: PropTypes.func,
  newDestination: PropTypes.func,
  setSelectRouting: PropTypes.func,
  selectRouting: PropTypes.object
}

export default Step3;